import { TextField, FunctionField, ArrayField, SingleFieldList, usePermissions } from 'react-admin';
import { Chip, Box } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import CheckmarkSmallIcon from '@/assets/icons/checkmark-small-icon.svg?react';
import { useDrawer } from '@/composables/useDrawer';
import { userContractorFieldStyles } from '@/themes/commonStyles/user.js';

const StyledContractorField = styled(Box)(userContractorFieldStyles);

export const UserContractorsField = ({ ...props }) => {
    const { openDrawer } = useDrawer();
    const { permissions } = usePermissions();
    const isAdminOrBok = permissions?.isAdmin || permissions?.isBok;

    return (
        <StyledContractorField>
            <ArrayField source='contractors' {...props} sx={{ '& .MuiTypography-root.MuiLink-root': { pointerEvents: 'none' } }}>
                <SingleFieldList empty={<></>} linkType={false}>
                    <FunctionField
                        render={record => (
                            <Chip
                                label={<TextField source='name' onClick={isAdminOrBok ? () => openDrawer(record.id, 'contractor-edit') : undefined} />}
                                icon={<CheckmarkSmallIcon />}
                                sx={{ cursor: isAdminOrBok ? 'pointer' : 'default' }}
                            />
                        )}
                    />
                </SingleFieldList>
            </ArrayField>
        </StyledContractorField>
    );
};

UserContractorsField.propTypes = {
    sortBy: PropTypes.string,
};
